import { styled, Box, Alert } from '@mui/material';
import Button from 'ihp-components/components/v2/Button';

export const Row = styled('div')(({ marginBottom }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  marginBottom: marginBottom || '20px',
}));

export const Buttons = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: 24,
}));

export const inputStyles = {
  svg: {
    marginRight: '20px',
  },
};

export const EmailValidationForm = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  width: '100%',
  marginTop: '20px',
}));

export const StyledAlert = styled(Alert)(() => ({
  fontSize: '14px',
  marginTop: '20px',
  padding: '6px 10px',
}));

export const SignInButton = styled(Button)(({ theme }) => ({
  fontSize: '15px',
  fontWeight: 700,
  padding: 0,
  height: 'auto',
  minHeight: 'unset',
  lineHeight: 'normal',
}));